import { FunctionComponent, memo } from 'react';
import { FormattedMessage } from 'react-intl';

import useCart from '../../../hooks/useCart';
import CartItem from './CartItem/CartItem';
import { ColumnHeader } from './CartItems.styles';
import messages from './CartItems.messages';
import { pushEcommerceEvent } from '../../../tracking';
import { convertToEuro } from '../../../helpers';

const CartItems: FunctionComponent = () => {
  const { items, setItemQuantity, removeItem, storeConfig } = useCart();

  const handleRemoveItem = (itemUid) => {
    const removingProduct = items?.find((item) => item?.uid === itemUid);
    const { product, prices, quantity } = removingProduct || {};
    const { value: price, currency } = prices?.rowTotalIncludingTax || {};

    pushEcommerceEvent('Remove from Cart', {
      currencyCode: currency,
      remove: {
        products: [
          {
            name: product?.name,
            id: product?.sku,
            price: convertToEuro(price, currency),
            quantity,
            brand: '',
            category: '',
          },
        ],
      },
    });

    removeItem(itemUid);
  };

  return (
    <>
      {/* needed to maintain grid layout */}
      <ColumnHeader />
      <ColumnHeader>
        <FormattedMessage {...messages.product} />
      </ColumnHeader>
      <ColumnHeader>
        <FormattedMessage {...messages.price} />
      </ColumnHeader>
      <ColumnHeader>
        <FormattedMessage {...messages.quantity} />
      </ColumnHeader>
      <ColumnHeader hAlign="right">
        <FormattedMessage {...messages.total} />
      </ColumnHeader>
      {items?.map((item) =>
        item ? (
          <CartItem
            item={item}
            onQuantitySelect={setItemQuantity}
            onRemove={handleRemoveItem}
            key={item.uid}
            includingTax={storeConfig?.taxSalesDisplayPrice === 'including'}
          />
        ) : null
      ) ?? null}
    </>
  );
};

export default memo(CartItems);
